<template>
  <svg
  class="color-box"
    width="12"
    height="17"
    viewBox="0 0 12 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 1771">
      <g id="Pin">
        <g id="Group 104">
          <mask
            id="mask0_5321_2898"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="12"
            height="17"
          >
            <path
              id="Subtract"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.99961 17C4.15794 14.9421 0.474609 9.75263 0.474609 5.4579C0.474609 1.16316 4.15794 0.0298246 5.99961 0C7.84128 0.0298246 11.5246 1.16316 11.5246 5.4579C11.5246 9.75263 7.84128 14.9421 5.99961 17ZM6.07114 7.95297C7.20989 7.95297 8.13303 7.02984 8.13303 5.89109C8.13303 4.75234 7.20989 3.82921 6.07114 3.82921C4.9324 3.82921 4.00926 4.75234 4.00926 5.89109C4.00926 7.02984 4.9324 7.95297 6.07114 7.95297Z"
              fill="#285C4D"
            />
          </mask>
          <g mask="url(#mask0_5321_2898)">
            <path
              id="Subtract_2"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M5.99961 17C4.15794 14.9421 0.474609 9.75263 0.474609 5.45789C0.474609 1.16316 4.15794 0.0298246 5.99961 0C7.84128 0.0298246 11.5246 1.16316 11.5246 5.45789C11.5246 9.75263 7.84128 14.9421 5.99961 17ZM6.07113 7.9525C7.20988 7.9525 8.13301 7.02936 8.13301 5.89062C8.13301 4.75187 7.20988 3.82874 6.07113 3.82874C4.93239 3.82874 4.00925 4.75187 4.00925 5.89062C4.00925 7.02936 4.93239 7.9525 6.07113 7.9525Z"
              fill="#9D432C"
            />
            <rect
              id="Rectangle 80"
              x="0.474609"
              width="5.59654"
              height="17.0842"
              fill="#781D06"
            />
          </g>
        </g>
      </g>
      <g id="Group 105">
        <mask
          id="mask1_5321_2898"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="17"
        >
          <path
            id="Subtract_3"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.99961 17C4.15794 14.9421 0.474609 9.75263 0.474609 5.4579C0.474609 1.16316 4.15794 0.0298246 5.99961 0C7.84128 0.0298246 11.5246 1.16316 11.5246 5.4579C11.5246 9.75263 7.84128 14.9421 5.99961 17ZM6.07114 7.95297C7.20989 7.95297 8.13303 7.02984 8.13303 5.89109C8.13303 4.75234 7.20989 3.82921 6.07114 3.82921C4.9324 3.82921 4.00926 4.75234 4.00926 5.89109C4.00926 7.02984 4.9324 7.95297 6.07114 7.95297Z"
            fill="#285C4D"
          />
        </mask>
        <g mask="url(#mask1_5321_2898)">
          <path
            id="Subtract_4"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.99961 17C4.15794 14.9421 0.474609 9.75263 0.474609 5.45789C0.474609 1.16316 4.15794 0.0298246 5.99961 0C7.84128 0.0298246 11.5246 1.16316 11.5246 5.45789C11.5246 9.75263 7.84128 14.9421 5.99961 17ZM6.0709 7.95288C7.20964 7.95288 8.13278 7.02974 8.13278 5.891C8.13278 4.75225 7.20964 3.82911 6.0709 3.82911C4.93215 3.82911 4.00901 4.75225 4.00901 5.891C4.00901 7.02974 4.93215 7.95288 6.0709 7.95288Z"
            fill="#717B07"
          />
          <rect
            id="Rectangle 80_2"
            x="0.474609"
            width="5.59654"
            height="17.0842"
            fill="#929F00"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
